<template>
  <div
    class="o-alert u-padding-bottom-xlarge-xs-down u-padding-bottom o-alert--warning u-margin-0 u-padding-xsmall"
  >
    <i class="icofont-warning"></i> {{ $t("projectDetail.isOldLogBar") }}
    <Button
      class="u-float-right u-margin-top-xsmall"
      variant="warning"
      :disabled="project.isLocked"
      @click="showModal = true"
      size="sm"
    >
      <i class="icofont-ui-lock" v-if="project.isLocked"></i>
      {{ $t("common.reactivate") }}
    </Button>
    <UpdateModal
      v-model="showModal"
      @ok="REACTIVE_PROJECT"
      :description="$t('projectDetail.isOldLogBarReactiveDescription')"
    ></UpdateModal>
  </div>
</template>

<script>
import Requests from "@/services/Requests";
import Button from "../Base/Button.vue";
import UpdateModal from "@/components/Shared/UpdateModal/index.vue";
export default {
  components: {
    Button,
    UpdateModal,
  },
  data() {
    return {
      showModal: false,
    };
  },
  props: {
    project: {
      type: Object,
      required: true,
    },
  },
  methods: {
    async REACTIVE_PROJECT(loading) {
      loading(true);
      const response = await Requests.Project.ReactivateProject({
        id: this.project.id,
      });
      if (response.message === "OK") {
        this.$store.dispatch("SET_ACTION_MODAL", {
          isLoading: false,
          status: true,
          message: this.$t(`updateProjects.success`),
          variant: "success",
          duration: 2500,
        });
        setTimeout(() => {
          location.reload();
        }, 2500);
      } else {
        this.$store.dispatch("SET_ACTION_MODAL", {
          isLoading: false,
          status: true,
          message: this.$t(`message.${response.message}.description`),
          variant: "danger",
          duration: 2500,
        });
      }
      loading(false);
    },
  },
};
</script>

<style></style>
